import axios from 'axios'
import { REACT_APP_API_ABM } from '../../config'

export async function getDefaultCurrency() {
  
  const exchangeRates = await axios(
    `${REACT_APP_API_ABM}/abms/exchange-rates?defaultCurrency=true`
  )
 
  return exchangeRates
}
